import { CONTACT, SOCIAL } from "../Components/Layout/nav";
import { SERVICES } from "../content/services";

/** Canonical origin — always the www host, https, no trailing slash. */
export const SITE_URL = "https://www.infinitudestack.com";
export const SITE_NAME = "Infinitude Stack";
export const LEGAL_NAME = "Infinitude Stack Inc.";
/** 1200×630 social share card in /public. */
export const OG_IMAGE = `${SITE_URL}/og-image.png`;

// Profiles Google uses to connect the brand. Add the Google Business Profile
// (and Clutch etc.) here once they exist — see the Launch checklist.
export const SAME_AS: string[] = [...SOCIAL.map((s) => s.href)];

/**
 * Structured data for Google: who we are, where we are, what we do.
 * ProfessionalService is a LocalBusiness subtype, so it is eligible for
 * local results ("software company Kitchener"). Only real facts here —
 * no ratings or reviews unless they come from a real review source.
 */
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#organization`,
  name: SITE_NAME,
  legalName: LEGAL_NAME,
  foundingDate: "2023",
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/logo.png`,
  image: OG_IMAGE,
  description:
    "Software development studio in Kitchener, Ontario. Web development, mobile apps, cloud & DevOps, UX/UI design, QA, digital marketing and ongoing support.",
  telephone: "+1-519-504-9076",
  email: CONTACT.email,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Kitchener",
    addressRegion: "ON",
    addressCountry: "CA",
  },
  areaServed: [
    { "@type": "City", name: "Kitchener" },
    { "@type": "City", name: "Waterloo" },
    { "@type": "City", name: "Cambridge" },
    { "@type": "AdministrativeArea", name: "Ontario" },
    { "@type": "Country", name: "Canada" },
  ],
  knowsAbout: [
    "Web development",
    "Mobile app development",
    "React",
    "React Native",
    "Flutter",
    "Node.js",
    "Cloud migration",
    "DevOps",
    "UX/UI design",
    "Software testing",
    "Digital marketing",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Software development services",
    itemListElement: SERVICES.map((s) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name: s.name, description: s.short },
    })),
  },
  ...(SAME_AS.length ? { sameAs: SAME_AS } : {}),
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: `${SITE_URL}/`,
  name: SITE_NAME,
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en-CA",
};

/** Breadcrumb trail for an inner page (Home › Page) — shown in Google results. */
export const breadcrumbSchema = (name: string, path: string) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
    { "@type": "ListItem", position: 2, name, item: `${SITE_URL}${path}` },
  ],
});
